import {Formik, Field} from 'formik'
import {Modal, Form} from 'react-bootstrap'
import * as Yup from 'yup'
import {useGetCampaignProducts, useGetRewardDetail} from '../../context/useQuery'
import {useCreateVIPCampaign, useUpdateVIPCampaign} from '../../context/useMutation'
import {useEffect, useState} from 'react'
import {useVIP} from '../../hook'
import {toast} from 'react-toastify'

import CampaignEdit from '../campaignData'
import {useIntl} from 'react-intl'

const RefModal = ({tierID, isOpen, onClose, refetch}) => {
  const intl = useIntl()

  const {mutateAsync: createVIPCampaign, isLoading: createIsLoading} = useCreateVIPCampaign()
  const {mutateAsync: updateVIPCampaign, isLoading: updateIsLoading} = useUpdateVIPCampaign()
  const {data} = useGetRewardDetail()
  // const { } = useGetCampaignProducts()

  const [section, setSection] = useState(1)
  const {
    program,
    campaignFilesState,
    deleteFileIdsState,
    uploadFileIdsState,
    selectedCampaignProduct,
    selectedGiveAwayProductSet,
    selectedGiveAwayProduct,
    vipCampaignProductList,
  } = useVIP()

  const createCampaign = async (values: any, products: any, program: any) => {
    await createVIPCampaign({values, tierID, products, uploadFileIdsState})
    refetch()
    onClose(false)
  }

  const updateCampaign = async (
    values: any,
    campaignID: string,
    selectedProducts: string[],
    defaultProducts: string[]
  ) => {
    const removedProductsId = defaultProducts.filter(
      (product) => !selectedProducts.includes(product)
    )
    const addedProductsId = selectedProducts.filter((product) => !defaultProducts.includes(product))

    const product = {
      removedProductsId,
      addedProductsId,
    }

    await updateVIPCampaign({
      values,
      campaignID,
      product,
      uploadFileIdsState,
      deleteFileIdsState,
    })
    refetch()
    onClose(false)
  }

  const handleSubmit = (values) => {
    if (values.name === '') {
      toast.warning(intl.formatMessage({id: 'CAMPAIGN.ENTER_NAME'}))
      return
    }

    if (values.name.length < 3 || values.name.length > 50) {
      toast.warning(intl.formatMessage({id: 'CAMPAIGN.NAME.LENGTH'}))
      return
    }

    const fileIds = [...uploadFileIdsState, ...campaignFilesState]

    if (
      (values.productInSelectionType === '3' || values.productOutSelectionType === '3') &&
      fileIds.length === 0
    ) {
      toast.warning(intl.formatMessage({id: 'CAMPAIGN.UPLOAD_FILE'}))
      return
    }

    if (
      values.promoGroup === '11' &&
      values.campaignType === '11' &&
      (values.pointsToBeEarned === '' ||
        values.pointsToBeEarned <= 0 ||
        values.pointsToBeEarned >= 100000 ||
        values.amountToBeSpent === '' ||
        values.amountToBeSpent <= 0 ||
        values.amountToBeSpent >= 100000)
    ) {
      toast.warning(intl.formatMessage({id: 'CAMPAIGN.ENTER_POINTS_AMOUNT'}))
      return
    }

    if (
      (values.promoGroup === '1' || values.campaignType === '1') &&
      values.priceCluster.length === 0
    ) {
      toast.warning(intl.formatMessage({id: 'CAMPAIGN.SELECT_PRICE_CLUSTER'}))
      return
    }

    if (
      values.promoCluster === '9' &&
      (values.fixedValue === '' || values.fixedValue <= 0 || values.fixedValue > 100000)
    ) {
      toast.warning(intl.formatMessage({id: 'CAMPAIGN.ENTER_FIXED_VALUE'}))
      return
    }

    if (values.productInSelectionType === '2' && selectedCampaignProduct.length === 0) {
      toast.warning(intl.formatMessage({id: 'CAMPAIGN.SELECT_PRODUCT.MIN.1'}))
      return
    }

    if (values.promoGroup === '6' && selectedGiveAwayProduct.length === 0) {
      toast.warning(intl.formatMessage({id: 'CAMPAIGN.SELECT_PRODUCT.GIVE_AWAY.MIN.1'}))
      return
    }

    if (!data) {
      const products = selectedCampaignProduct.map((product) => product.id)
      createCampaign(values, products, program)
    } else {
      const selectedProducts = selectedCampaignProduct.map((product) => product.id)
      const defaultProducts = vipCampaignProductList.data.map((product) => product.id)
      updateCampaign(values, data.campaign.id, selectedProducts, defaultProducts)
    }
  }

  useEffect(() => {
    if (data && data.campaignPriceClusterList.length > 0) {
      const productList = data.campaignPriceClusterList[0].productList
      selectedGiveAwayProductSet(productList)
    }
  }, [data])

  const formikData = data
    ? {
        name: data.campaign.name,
        promoCluster: data.campaign.promoCluster.toString(),
        promoType: data.campaign.promoType.toString(),
        promoGroup: data.campaign.promoGroup.toString(),
        priceCluster: data.campaignPriceClusterList,
        pointsToBeEarned: data.campaignPoint?.pointsToBeEarned.toString(),
        amountToBeSpent: data.campaignPoint?.amountToBeSpent.toString(),
        fixedValue: data.campaignPoint?.fixedValue.toString(),
        productInSelectionType: data.productInSelectionType.toString(),
        productOutSelectionType: data.productOutSelectionType.toString(),
        campaignType:
          data.campaign.promoGroup === 11 && data.campaign.promoCluster === 2
            ? '1'
            : data.campaign.promoGroup === 1 && data.campaign.promoCluster === 1
            ? '2'
            : '3',
      }
    : {
        name: '',
        campaignType: '1', // 1 Point, 2 Discount, 3 Birthday
        discountControlType: '1', //1 Moneraty, 2 Quentitive
        promoCluster: '2',
        promoType: '0',
        promoGroup: '11',
        priceCluster: [],
        productType: '0',
        pointsToBeEarned: '0',
        amountToBeSpent: '0',
        fixedValue: '0',
        productInSelectionType: '1',
        productOutSelectionType: '0',
      }

  const validSchema = Yup.object({
    name: Yup.string()
      .required(intl.formatMessage({id: 'GLOBAL.VALIDATION.REQUIRED_FIELD'}))
      .min(3, intl.formatMessage({id: 'GLOBAL.VALIDATION.MIN_LENGTH_FIELD'}, {length: 3}))
      .max(50, intl.formatMessage({id: 'GLOBAL.VALIDATION.MAX_LENGTH_FIELD'}, {length: 50})),
  })

  return (
    <Modal show={isOpen} onHide={() => onClose(false)} size='xl'>
      <Modal.Body>
        {/* campaignType = {formikData.campaignType}
        promoGroup = {formikData.promoGroup}
        promoCluster = {formikData.promoCluster} */}
        <Formik
          initialValues={formikData}
          enableReinitialize
          validationSchema={validSchema}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({setFieldValue, values, errors, touched, submitForm}) => {
            return (
              <>
                <CampaignEdit
                  setFieldValue={setFieldValue}
                  values={values}
                  errors={errors}
                  touched={touched}
                  Form={Form}
                  Field={Field}
                  section={section}
                  setSection={setSection}
                  disabled={data ? true : false}
                />
                {section === 1 && (
                  <div className='modal-footer'>
                    {data ? (
                      <>
                        <button
                          type='button'
                          className='btn btn-light'
                          onClick={() => {
                            onClose(false)
                          }}
                        >
                          {intl.formatMessage({id: 'GLOBAL.BUTTON.CLOSE'})}
                        </button>
                      </>
                    ) : (
                      <>
                        <button
                          type='button'
                          className='btn btn-light'
                          onClick={() => {
                            onClose(false)
                          }}
                        >
                          {intl.formatMessage({id: 'GLOBAL.CANCEL'})}
                        </button>
                        <button
                          onClick={submitForm}
                          className='btn btn-primary'
                          disabled={createIsLoading || updateIsLoading}
                        >
                          {intl.formatMessage({id: 'GLOBAL.SAVE'})}
                        </button>
                      </>
                    )}
                  </div>
                )}
              </>
            )
          }}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}

export default RefModal
